import { createContext, useContext } from "react";

// Signals to the reused consultant detail pages (SmartEvaluate /
// SmartImprove) that they are being rendered for a read-only CLIENT via
// Client Access Management. When null, the page behaves exactly as the
// normal consultant surface (zero behavioural change for consultants/admins).
//
// Shape: { readOnly: true, module, assignmentId, backTo }
export const ClientAssignmentContext = createContext(null);

export const useClientAssignment = () => useContext(ClientAssignmentContext);
